import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { groupBy } from 'lodash';

import useSuspenseQuery from 'commons/useSuspenseQuery';
import { GET_ORDER_INFO } from 'mocks/queries';
import OrderSuccessNew from 'components/consumer/checkout/desktop/components/OrderSuccessNew/OrderSuccessNew';

const OrderSummary = ({ order_id }) => {
  const [orderInfo, setOrderInfo] = useState(null);
  const { loading, data, error } = useSuspenseQuery(GET_ORDER_INFO, {
    fetchPolicy: 'cache-and-network',
    variables: {
      order_id,
    },
    skip: !order_id,
  });

  useEffect(() => {
    if (!data) {
      return;
    }
    const order = data.getOrderInfo?.order || {};
    const orderSummary = {
      grand_total: order.total_order_amount,
      cart_subtotal: order.order_subtotal,
      protectionSubtotal: order.cart_protection_subtotal,
      discount: order.coupon_discount,
      total_shipping: order.addditional_services,
      tax_amount: order.tax_charge,
      gift_used: order.gift_used,
      gift_card_rewards_used: order.gift_card_rewards_used,
    };
    let shipping = order.shipping || {};
    shipping = {
      first_name: shipping.address_first_name,
      last_name: shipping.address_last_name,
      address: shipping.address_street1,
      city: shipping.address_city,
      apartment: shipping.apartment,
      company: shipping.address_company,
      state: shipping.address_state,
      zipcode: shipping.address_zip_code,
      phone_number: shipping.address_phone,
      shipping_sms: false,
    };
    let payment = {};
    if (order.payment?.[0]?.payment_type === 'Credit Card') {
      payment = {
        selected_type: 'credit_card',
        split_payment: false,
        credit_cards: order.payment.map(p => ({
          number: p.card_no,
          amount: p.payment_amount,
        })),
      };
    } else if (order.payment?.[0]?.payment_type === 'Affirm') {
      payment = {
        selected_type: 'affirm',
      };
    } else if (order.payment?.[0]?.payment_type === 'Apple Pay') {
      payment = {
        selected_type: 'apple_pay',
      };
    } else if (order.payment?.[0]?.payment_type === 'PayPal') {
      payment = {
        selected_type: 'paypal',
      };
    }
    const cartData = order.order_items?.length
      ? order.order_items.map(item => ({
          ...item,
          id: item.product_id,
        }))
      : [];

    const groups = groupBy(cartData, 'shipping_group');
    const deliveryInfo = {
      production_selection: {},
      production_selection_add: {},
    };
    const shippingGroups = groups
      ? Object.entries(groups).map(([id, group]) => {
          deliveryInfo.production_selection[id] = {};
          deliveryInfo.production_selection_add[id] = {};
          return {
            id,
            cart: group,
          };
        })
      : [];
    setOrderInfo({
      orderId: order.order_id,
      orderSummary,
      shipping,
      payment,
      cartData,
      shippingGroups,
      deliveryInfo,
    });
  }, [data]);

  if (error) return `Error!: ${error}`;

  return (
    <div className="OrderSummary">
      {loading ? (
        <div className="text-lg font-bold flex items-center justify-center">
          Loading..
        </div>
      ) : null}
      {orderInfo && (
        <OrderSuccessNew
          orderId={order_id}
          orderSummary={orderInfo.orderSummary}
          shipping={orderInfo.shipping}
          payment={orderInfo.payment}
          cartData={orderInfo.cartData}
          shippingGroups={orderInfo.shippingGroups}
          deliveryInfo={orderInfo.deliveryInfo}
        />
      )}
    </div>
  );
};

OrderSummary.propTypes = {
  order_id: PropTypes.string,
};

export default OrderSummary;
